import { SelectOption } from "common/components/Select";
import { ContentStatus } from "__generated__/types";

export function contentStatusLabel(value: ContentStatus): string {
  switch (value) {
    case ContentStatus.DRAFT:
      return "utkast";
    case ContentStatus.PUBLISHED:
      return "publisert";
    case ContentStatus.ARCHIVED:
      return "arkivert";
    case ContentStatus.DELETED:
      return "slettet";
  }
}

export function contentStatusToSelectOption(
  contentStatus: ContentStatus,
): SelectOption {
  return {
    key: contentStatus.toString(),
    value: contentStatus.toString(),
    label: contentStatusLabel(contentStatus),
  };
}

export function contentStatusOptions(): SelectOption[] {
  return Object.values(ContentStatus)
    .filter((v) => v !== ContentStatus.DELETED)
    .map(contentStatusToSelectOption);
}
